import type { RouterInputs } from "@/types/rpc";
import { orpc } from "@/utils/orpc.client";

export type SearchFacetInput = RouterInputs["music"]["searchFacet"];

export function getSearchFacetQueryOptions(input: SearchFacetInput) {
  return orpc.music.searchFacet.queryOptions({ input });
}
